module.exports = __webpack_public_path__ + "static/media/yuce001.cb800649.png";